// @ts-nocheck
import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useClickOutside } from "hooks";
import { CloseButtonModal } from "components/CloseButton";
import { useStores } from "hooks/useStores";
import {INVALIDATION_TIP, REGEX} from "../../const/validation";

const Background = styled.div`
  display: none;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background: rgba(34, 34, 34, 0.5);
  z-index: 1010;
`;

const Container = styled.div`
  width: 588px;
  background-color: #ffffff;
  position: relative;
  padding: 90px 92px;

  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 600px) {
    width: 100vw;
  }
`;

const Title = styled.h1`
  font-family: Noah;
  font-style: normal;
  font-weight: 500;
  font-size: 46px;
  line-height: 56px;
  margin: 0 0 40px;
  text-align: center;
  @media (max-width: 800px) {
    font-size: 30px;
  }
  @media (max-width: 500px) {
    font-size: 24px;
  }
`;

const Label = styled.label`
  margin-bottom: 4px;

  font-family: Gilroy;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 160%;
`;

const InputStyle = styled.input`
  width: 404px;
  height: 46px;
  background: #ffffff;
  border: 2px solid #dddde3;
  border-radius: 6px;

  font-family: Gilroy;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 160%;
  padding-left: 12px;

  @media (max-width: 600px) {
    width: 250px;
  }
`;

const Button = styled.button`
  width: 404px;
  height: 46px;
  background: #ffd600;
  border: none;
  border-radius: 6px;

  font-family: Gilroy;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 160%;

  display: flex;
  justify-content: center;
  align-items: center;

  cursor: pointer;

  &:hover {
    background: #fbca1f;
  }
  &:disabled {
    background: #fff0b9;
  }
  @media (max-width: 600px) {
    width: 250px;
  }
`;

const ErrorMessage = styled.p`
  font-family: Proxima Nova;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 140%;
  color: #f10b13;
  margin-top: 4px;
`;

const ContainerMain = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const ContainerSucces = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const FormItem = styled.div`
  margin-bottom: 18px;
  position: relative;
  display: flex;
  flex-direction: column;

  @media (max-width: 800px) {
    margin-bottom: 15px;
  }
  @media (max-width: 500px) {
    margin-bottom: 10px;
  }
`;

const ShowHidePass = styled.div`
  position: absolute;
  width: 71px;
  height: 20px;
  background-color: #fff0b9;
  top: 38px;
  left: 324px;
  cursor: pointer;
  border: none;
  padding: 0;
  margin: 0;

  font-family: Gilroy;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 160%;
  text-align: center;

  @media (max-width: 600px) {
    left: 170px;
  }
`;

const schema = yup.object().shape({
  old_password: yup
    .string()
    .required(INVALIDATION_TIP.FIELD_REQUIRED)
    .min(8, INVALIDATION_TIP.MIN_LENGTH_PASSWORD )
    .max(16, INVALIDATION_TIP.MAX_LENGTH_PASSWORD)
    .matches(
      REGEX.VALID_PASSWORD,
      INVALIDATION_TIP.INCORRECT_PASSWORD,
    ),
  password: yup
    .string()
    .required(INVALIDATION_TIP.FIELD_REQUIRED)
    .min(8, INVALIDATION_TIP.MIN_LENGTH_PASSWORD )
    .max(16, INVALIDATION_TIP.MAX_LENGTH_PASSWORD)
    .matches(
      REGEX.VALID_PASSWORD,
      INVALIDATION_TIP.INCORRECT_PASSWORD,
    )
    .notOneOf(
      [yup.ref("old_password"), null],
      INVALIDATION_TIP.MATCHES_OLD_PASSWORD,
    ),
  password2: yup
    .string()
    .required(INVALIDATION_TIP.FIELD_REQUIRED)
    .oneOf([yup.ref("password"), null], INVALIDATION_TIP.MATCHES_PASSWORD)
    .required(INVALIDATION_TIP.FIELD_REQUIRED),
});

export default function LkChangePassword(props) {
  const [passwordChanged, setPasswordChanged] = useState(false);
  const [incorrectCode, setIncorrectCode] = useState(false);
  const [error, setError] = useState();

  const { api } = useStores()

  const containerRef = useClickOutside(() => {
    closeChangePass();
  })

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setFocus,
  } = useForm({
    mode: "onBlur",
    resolver: yupResolver(schema),
  });

  useEffect(() => {
    setFocus("old_password");
  }, [props.modal]);

  const onSubmit = (data) => {
    api.user.putChangePassword({
      old_password: data.old_password,
      new_password: data.password,
      new_password2: data.password2,
    })
      .then((res) => {
        setPasswordChanged(true);
      })
      .catch((err) => {
        if (err.response.data.new_password !== undefined) {
          setError("новый пароль слишком простой, попробуйте другой");
        }
        if (err.response.data.old_password !== undefined) {
          setError("вы неверно ввели старый пароль");
        }
        if (err.response.status === 500) {
        }
        setIncorrectCode(true);
      });
  };

  const closeChangePass = () => {
    document.querySelector("#changePasswordPopup").style.display = "none";
    reset({
      old_password: "",
      password: "",
      password2: "",
    });
    setPasswordChanged(false);
  };

  const [oldPasswordShown, setOldPasswordShown] = useState(false);
  const toggleOldPasswordVisiblity = () => {
    setOldPasswordShown(oldPasswordShown ? false : true);
  };

  const [passwordShown, setPasswordShown] = useState(false);
  const togglePasswordVisiblity = () => {
    setPasswordShown(passwordShown ? false : true);
  };

  const [passwordShown2, setPasswordShown2] = useState(false);
  const togglePasswordVisiblity2 = () => {
    setPasswordShown2(passwordShown2 ? false : true);
  };

  return (
    <Background id='changePasswordPopup'>
      <Container ref={containerRef}>
      <CloseButtonModal handleClose={closeChangePass}/>
        {passwordChanged ? (
          <ContainerSucces id='containerSucces'>
            <Title>Пароль успешно изменен!</Title>
            <Button onClick={closeChangePass}>Перейти в личный кабинет</Button>
          </ContainerSucces>
        ) : (
          <ContainerMain id='containerMain'>
            <Title>Изменение пароля</Title>
            {incorrectCode && <ErrorMessage>{error}</ErrorMessage>}
            <Form onSubmit={handleSubmit(onSubmit)}>
              <FormItem>
                <Label htmlFor='old_password'>
                  Введите старый пароль
                  <span className='lk-personal-form__span'>*</span>
                </Label>
                <InputStyle
                  autoFocus
                  {...register("old_password")}
                  id='old_password'
                  name='old_password'
                  type={oldPasswordShown ? "text" : "password"}
                />
                <ShowHidePass onClick={toggleOldPasswordVisiblity}>
                  {oldPasswordShown ? <>скрыть</> : <>показать</>}
                </ShowHidePass>
                <p className='lk-reg-form__err'>
                  {errors.old_password?.message}
                </p>
              </FormItem>
              <FormItem>
                <Label htmlFor='password'>
                  Введите новый пароль
                  <span className='lk-personal-form__span'>*</span>
                </Label>
                <InputStyle
                  autoFocus
                  {...register("password")}
                  id='password'
                  name='password'
                  type={passwordShown ? "text" : "password"}
                />
                <ShowHidePass onClick={togglePasswordVisiblity}>
                  {passwordShown ? <>скрыть</> : <>показать</>}
                </ShowHidePass>
                <p className='lk-reg-form__err'>{errors.password?.message}</p>
              </FormItem>
              <FormItem>
                <Label htmlFor='password2'>
                  Введите новый пароль еще раз
                  <span className='lk-personal-form__span'>*</span>
                </Label>
                <InputStyle
                  {...register("password2")}
                  id='password2'
                  name='password2'
                  type={passwordShown2 ? "text" : "password"}
                />
                <ShowHidePass onClick={togglePasswordVisiblity2}>
                  {passwordShown2 ? <>скрыть</> : <>показать</>}
                </ShowHidePass>
                <p className='lk-reg-form__err'>{errors.password2?.message}</p>
              </FormItem>
              <Button>Сохранить изменения</Button>
            </Form>
          </ContainerMain>
        )}
      </Container>
    </Background>
  );
}
